import { create } from 'zustand';
export const remoteConfigStore = create()(() => ({
    flags: {},
    configs: {},
}));
